import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserLogin from './user-login';
import { post } from 'communication/httpClient';
import { ILoginUser } from './interfaces/dtos/ILoginUser';
import { ILoginUserErrors } from './interfaces/dtos/ILoginUserErrors';

const Login: React.FC = (): JSX.Element => {
  const [user, setLogin] = useState<ILoginUser>({
    userName: '',
    password: '',
    organization: '',
    token: '',
    error: '',
  });

  const [errors, setErrors] = useState<ILoginUserErrors>({
    userName: '',
    password: '',
    organization: '',
    description: '',
  });

  const { t } = useTranslation();

  function handleChange(name: string, value: string): void {
    setLogin(
      (prevUser: ILoginUser): ILoginUser => ({
        ...prevUser,
        [name]: value,
      })
    );

    setErrors(
      (prevErr: ILoginUserErrors): ILoginUserErrors => ({
        ...prevErr,
        description: '',
      })
    );
  }

  const loginProcess = async (): Promise<void> => {
    const response = await post('/api/principal', user);

    if (response.success) {
      window.location.reload();
    } else if (response.error) {
      setErrors({
        userName: '',
        password: '',
        organization: '',
        description: response.error ? response.error.message : 'Something went wrong...',
      });
    }
  };

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();

    errors.userName = !user.userName ? t('error.username') : '';
    errors.password = !user.password ? t('error.peakFord') : '';
    errors.organization = !user.organization ? t('error.organization') : '';

    if (errors.description) {
      return;
    }

    setErrors(
      (prevErr: ILoginUserErrors): ILoginUserErrors => ({
        ...prevErr,
        userName: errors.userName,
        password: errors.password,
        organization: errors.organization,
        description: '',
      })
    );

    if (!Object.values(errors).some(Boolean)) {
      loginProcess();
    }
  };

  return (
    <UserLogin
      user={user}
      setLogin={setLogin}
      errors={errors}
      onChange={handleChange}
      onLogin={handleLogin}
    />
  );
};

export default Login;
